import React, { useState } from "react";

function DescriptionCell({ description }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const words = description.split(" ");
  const truncated = words.slice(0, 4).join(" ");

  return (
    <td className="px-6 py-4 text-gray-700">
      {isExpanded ? description : `${truncated}${words.length > 4 ? "..." : ""}`}
      {words.length > 4 && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="ml-2 text-green-600 hover:underline text-xs"
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      )}
    </td>
  );
}

export default DescriptionCell;
